<script setup lang="ts">
import Section from '~/components/layout/external/desktop/Section.vue';

const localePath = useLocalePath();
</script>

<template>
  <Section :title="$t('layout.links.how-does-it-work')" :link="localePath('how-does-it-work')" />
</template>
